import { isNil } from 'lodash';
import * as moment from 'moment';
import { createSelector } from 'reselect';

import { DefaultDateFormats } from '../../../constants/dateFormats';

const selectPagesHistoryCalendar = (state: any) => {
  return state.pagesCalendar;
};

export const getSelectedDate = createSelector(
  selectPagesHistoryCalendar,
  (pagesCalendar: any) => {
    const selectedDate = pagesCalendar.selectedDate;

    return isNil(selectedDate) ? moment().format(DefaultDateFormats.fullDate) : selectedDate;
  },
);

export const getSelectedMonth = createSelector(
  selectPagesHistoryCalendar,
  (pagesCalendar: any) => {
    const selectedMonth = pagesCalendar.selectedMonth;

    return isNil(selectedMonth) ? moment().month() : selectedMonth;
  },
);

export const getSelectedYear = createSelector(
  selectPagesHistoryCalendar,
  (pagesCalendar: any) => {
    const selectedYear = pagesCalendar.selectedYear;

    return isNil(selectedYear) ? moment().year() : selectedYear;
  },
);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryCalendar/selectors.ts